import { PASSWORD_CHANGED } from '../core/action-types'

export const passwordChanged = () => {
  return (dispatch) => {
    return dispatch({ type: PASSWORD_CHANGED })
  }
}
